import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { webinarScheduleSchema } from "../../../../../utils/velidations";
import InputFieldB from "../../../../../components/ui/InputFieldB";
import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import TimezoneSelect from "react-timezone-select";
function Schedule({ data, setValue }) {
  const [helperText, setHelperText] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);
  const [selectedTimezone, setSelectedTimezone] = useState(
    data?.schedule?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    formData.duration = parseInt(formData?.duration || 0);
    formData.timeZone =
      typeof selectedTimezone === "object"
        ? selectedTimezone.value
        : selectedTimezone;
    const result = webinarScheduleSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    data.schedule = formData;
    setValue("format");
  };

  return (
    <Fragment>
      <Typography variant="typographyA">Schedule & Duration</Typography>
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <InputFieldB
          type="date"
          name="date"
          label="Date *"
          placeholder="Enter date"
          variant="outlined"
          helperText={helperText}
          slotProps={{
            htmlInput: { min: moment().format("YYYY-MM-DD") },
          }}
          defaultValue={
            data?.schedule?.startTime
              ? moment(data.schedule.startTime).format("YYYY-MM-DD")
              : ""
          }
        />
        <InputFieldB
          type="number"
          label="Duration in minutes*"
          name="duration"
          variant="outlined"
          helperText={helperText}
          placeholder="Enter duration in minutes"
          defaultValue={data?.schedule?.duration || ""}
        />
        <div>
          <Typography variant="body2" sx={{ mb: 0.5, color: "text.secondary" }}>
            Time Zone *
          </Typography>
          <TimezoneSelect
            value={selectedTimezone}
            onChange={setSelectedTimezone}
          />
        </div>
        <InputFieldB
          type="time"
          name="startTime"
          variant="outlined"
          label="Start time *"
          placeholder="Enter start time"
          helperText={helperText}
          defaultValue={
            data?.schedule?.startTime
              ? moment(data.schedule.startTime, [
                  "HH:mm",
                  moment.ISO_8601,
                ]).format("HH:mm")
              : ""
          }
        />

        <Stack direction="row" spacing={1}>
          <Button
            size="large"
            type="button"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            onClick={() => {
              setValue("basics");
            }}
          >
            Back
          </Button>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            endIcon={
              loadings?.create && (
                <CircularProgress size={20} color="text" thickness={5} />
              )
            }
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Fragment>
  );
}

export default Schedule;
